
export const PrivacyPolicyItems = [
    {
      title: { en: "Privacy Policy", ar: "سياسة الخصوصية" },
      description: {
        en: "The Saudi Arabian Football Federation (“the Federation,” “we,” or “us”) places the utmost importance on protecting the privacy and personal data of its users. This Privacy Policy explains how we collect, use, and safeguard information through our digital platforms, including websites and applications. It is drafted in accordance with best practices and in compliance with the Saudi Personal Data Protection Law and related Executive Regulations by the Saudi Data and Artificial Intelligence Authority (SDAIA), as well as the relevant rules of the National Cybersecurity Authority.",
        ar: "في الاتحاد السعودي لكرة القدم، نولي أعلى درجات الأهمية على حماية خصوصية مستخدمينا وبياناتهم الشخصية. تهدف هذه السياسة إلى توضيح كيفية جمع واستخدام وحماية المعلومات التي يتم جمعها من خلال منصاتنا الرقمية، بما في ذلك المواقع الإلكترونية والتطبيقات. تم إعداد هذه السياسة وفقاً لأفضل الممارسات امتثالاً لأحكام نظام حماية البيانات الشخصية ولوائحه التنفيذية الصادرة عن الهيئة السعودية للبيانات والذكاء الاصطناعي (سدايا)، وكذلك ضوابط الهيئة الوطنية للأمن السيبراني ذات الصلة."
      },
    },
    {
      title: { en: "Definitions", ar: "التعريفات" },
      description: 
      {
        en: `• “Federation,” “we,” “us”: Refers to the Saudi Arabian Football Federation, which owns and operates the platform.
• “User”: Any individual who accesses or uses the Federation’s website, applications, or digital services.
• “Platform”: All digital channels owned by the Federation, including its official website, mobile apps, and electronic services.
• “Personal Data”: Any information that directly or indirectly identifies the user.`,
        ar: `• "الاتحاد" أو "نحن": يُقصد بها الاتحاد السعودي لكرة القدم، الجهة المالكة والمسؤولة عن المنصة.
• "المستخدم": أي شخص يستخدم الموقع الإلكتروني أو التطبيقات أو الخدمات الرقمية الخاصة بالاتحاد.
• "المنصة": جميع القنوات الرقمية التابعة للاتحاد، بما في ذلك الموقع الرسمي والتطبيقات والخدمات الإلكترونية.
• "البيانات الشخصية": أي بيانات تؤدي إلى التعرف على هوية المستخدم بشكل مباشر أو غير مباشر.`
      }
    },
    {
      title: { en: "Introduction", ar: "1.  المقدمة" },
      description: {
        en: "By accessing or using the Platform, you expressly acknowledge and agree to this Privacy Policy. We are committed to handling your personal data responsibly, securely, transparently, and in a manner, that builds your trust.",
        ar: "باستخدامك لهذه المنصة، فإنك تقر وتوافق صراحةً على سياسة الخصوصية هذه. نحن ملتزمون بالتعامل مع بياناتك الشخصية بمسؤولية وأمان، مع ضمان الشفافية والثقة.",
      },
    },
    {
        title: { en: "2. Types of Data We Collect", ar: "2.    أنواع البيانات التي نجمعها" },
        description: undefined,
      },
      {
        title: { en: "• Direct Personal Data:", ar:  "•    البيانات الشخصية المباشرة " },
        description: {
        en: "Provided voluntarily by users via forms (e.g., name, email, phone number) during registration or communication.",
        ar:"يتم جمعها من خلال النماذج مثل (الاسم، البريد الإلكتروني، رقم الجوال) عند التواصل معنا أو التسجيل."
        },
      },
      {
        title: { en: "• Indirect Data (Automatically Collected):", ar:  "•    البيانات غير المباشرة: " },
        description: {
            en: "Gathered through cookies and similar technologies, including IP address, device type, preferred language, and geographic location.",
            ar: "يتم جمعها تلقائيًا من خلال ملفات تعريف الارتباط  (Cookies)، مثل عنوان الـ IP، نوع الجهاز، اللغة المفضلة، والموقع الجغرافي.",
        },
      },
    {
      title: { en: "3. Purpose of Data Collection", ar: "3.  الغرض من جمع البيانات" },
description: {
        en: `    • Enhance user experience and deliver more effective services;
    • Respond to user inquiries and requests;
    • Conduct statistical analysis and improve content quality.`,
        ar: `    •   تحسين تجربة المستخدم وتقديم خدمات أكثر كفاءة.
    •   الرد على استفسارات المستخدم وطلباته.
    •   التحليل الإحصائي وتحسين جودة المحتوى.`
      },
    },
    {
      title: { en: "4. Legal Basis for Processing", ar: "4.  الأساس النظامي للمعالجة" },
      description: {
        en: `We process data based on your consent or as required by applicable laws, including public interest, legal obligations, or contractual necessity. You have the right to withdraw consent at any time unless processing is legally permitted or required.`,
        ar: `نقوم بمعالجة البيانات بناءً على موافقة المستخدم أو حسب ما تقتضيه الأنظمة والقوانين، بما يشمل المصلحة العامة أو الالتزامات القانونية أو التعاقدية. للمستخدم الحق في سحب موافقته ما لم يكن هناك سبب نظامي مشروع للاستمرار.`,
      },
    },
    {
      title: { en: "5. Disclosure of Personal Data", ar: "5.   الإفصاح عن البيانات" },
      description: {
        en: `Your data is disclosed only when legally justified, including:\n
    • To comply with legal or regulatory obligations.
    • For public interest or safety reasons.
    • To fulfill contractual obligations or service delivery.
    • To licensed service providers bound by data protection commitments.`,
        ar: `نقوم بمشاركة بياناتك الشخصية فقط عند وجود مبرر نظامي، مثل:\n
    •   الامتثال للالتزامات القانونية والتنظيمية.
    •   تحقيق المصلحة العامة (مثل الصحة أو السلامة).
    •   تنفيذ عقد أو تقديم خدمة بناءً على طلب المستخدم.
    •   مع مزودي خدمات مرخصين ومتعاقدين معنا يلتزمون بحماية بياناتك.`,
      },
    },
    {
      title: { en: "6. Data Storage", ar: "6.  تخزين البيانات" },
      description: {
        en: `All personal data is securely stored on servers located within the Kingdom of Saudi Arabia. International data transfers are only permitted if legally authorized.`,
        ar: `يتم تخزين جميع البيانات الشخصية على خوادم آمنة داخل المملكة العربية السعودية. ولا يُسمح بنقل البيانات خارج المملكة إلا إذا كان ذلك معتمدًا نظاميًا.`,
      },
    },
    {
      title: { en: "7. Data Security", ar: "7.    حماية البيانات" },
      description: {
        en: `We employ administrative, technical, and organizational safeguards aligned with the National Cybersecurity Authority’s standards, to prevent unauthorized access, loss, or damage.`,
        ar: `نطبق تدابير أمنية إدارية وتقنية وتنظيمية، وفقًا لضوابط الهيئة الوطنية للأمن السيبراني، لحماية بياناتك من الوصول غير المصرح به أو الفقدان.`,
      },
    },
    {
      title: { en: "8. Data Retention", ar: "8.    فترة الاحتفاظ بالبيانات" },
      description: {
        en: `Personal data is retained only as long as necessary to fulfill the purpose for which it was collected, or as required by law. Once no longer needed, data is securely deleted.`,
        ar: `نحتفظ بالبيانات فقط للمدة اللازمة لتحقيق الغرض الذي جُمعت من أجله، أو كما تقتضيه الأنظمة ذات العلاقة. ويتم حذفها بأمان عندما لا تكون هناك حاجة إليها.`,
      },
    },
    {
        title: { en: "9. User Rights", ar: "9.  حقوق المستخدم" },
        description: {
          en: `Under applicable law, users have the right to:\n
    • Access their personal data.
    • Correct or update inaccurate data.
    • Delete or restrict processing of their data.
    • Submit complaints to competent authorities if their rights are violated.`,
          ar: `للمستخدم وفقاً للنظام:\n
    •   طلب الوصول إلى بياناتك الشخصية.
    •   طلب تصحيح أو تحديث بياناتك غير الدقيقة.
    •   طلب حذف البيانات أو تقييد المعالجة.
    •   تقديم شكوى إلى الجهة المختصة إذا تم انتهاك حقوقك.          `,
        },
      },
      {
        title: { en: "10. Data of Minors", ar: "10.  بيانات القُصّر" },
        description: {
          en: `We do not knowingly collect personal data from individuals under 18 without explicit parental or guardian consent. Parents are encouraged to oversee their children's platform usage. If data is collected inadvertently, please contact us to request deletion.`,
          ar: `لا نقوم بجمع بيانات من الأفراد دون سن 18 عامًا دون موافقة صريحة من ولي الأمر. نوصي أولياء الأمور بمراقبة استخدام أبنائهم للمنصة. في حال تم جمع بيانات دون قصد، نرجو التواصل معنا لحذفها.
          `,
        },
      },
      {
        title: { en: "11. Consent", ar: "11.  الموافقة" },
        description: {
          en: `Your continued use of the Platform constitutes explicit consent to process your personal data as outlined above.`,
          ar: `إن استمرار استخدامك للمنصة يُعد موافقة صريحة على معالجة بياناتك الشخصية كما هو موضح أعلاه.`,
        },
      },
      {
        title: { en: "12. External Links", ar: "12.  الروابط الخارجية" },
        description: {
          en: `The Platform may include links to third-party websites. We are not responsible for their content, privacy policies, or security practices. We encourage users to review the privacy policies of those sites separately.`,
          ar: `قد تحتوي المنصة على روابط لمواقع خارجية لا تخضع لسيطرتنا. لا نتحمل مسؤولية محتواها أو ممارسات الخصوصية الخاصة بها ونوصي المستخدم بمراجعة تلك السياسات الخاصة بالمواقع قبل استخدام خدماتها.`,
        },
      },
      {
        title: { en: "13. Policy Updates", ar: "13.  تحديثات سياسة الخصوصية" },
        description: {
          en: `We reserve the right to amend this Privacy Policy at any time. Material changes will be communicated via email or through notifications on the Platform. Continued use after such amendments constitutes consent to the updated policy.`,
          ar: `نحتفظ بالحق في تعديل هذه السياسة في أي وقت. وسيتم إخطار المستخدمين بالتغييرات الجوهرية سواء عبر البريد الإلكتروني أو داخل المنصة، ويعد استمرار الاستخدام بعد التعديل موافقة ضمنية على النسخة الجديدة`,
        },
      },
      {
        title: { en: "14. Contact Us", ar: "14.  تواصل معنا" },
        description: {
          en: `For inquiries or to exercise your rights please contact: [info@saff.com.sa].`,
          ar: `للاستفسارات أو لممارسة حقوقك، يرجى التواصل معنا عبر: [info@saff.com.sa].`,
        },
      },
  ];